import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTranslation } from "../../translations/getTranslations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette, faLanguage, faMoon, faSun, faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { setTheme, setLanguage } from "../../redux/slices/settingsSlice";

const PreferencesForm = ({ isMobile }) => {
  const language = useSelector(state => state.settings.language);
  const theme = useSelector(state => state.settings.theme);
  const translation = key => getTranslation("preferencesForm", key, language);
  const dispatch = useDispatch();

  const handleLanguageChange = e => {
    dispatch(setLanguage(e.target.value));
  };

  const handleThemeToggle = () => {
    dispatch(setTheme(theme === "light" ? "dark" : "light"));
  };

  return (
    <div className="text-lg">
      <div className="mb-2 flex items-center text-2xl font-semibold">
        <FontAwesomeIcon icon={faAsterisk} className="mr-2" /> {translation("_preferences")}
      </div>
      <p>{translation("_preferencesDescription")}</p>

      <div className={`flex ${isMobile ? "flex-col items-center" : "items-center"} 2xl:flex-col 2xl:items-start`}>
        <div className={`my-4 flex items-center ${isMobile ? "w-full justify-center" : "w-[250px]"}`}>
          <FontAwesomeIcon icon={faLanguage} className="mr-2" />
          {translation("_languages")}
        </div>
        <div className="flex w-full">
          <select
            value={language}
            onChange={handleLanguageChange}
            className={`h-[40px] ${isMobile ? "w-[90%]" : "w-[350px]"} cursor-pointer rounded bg-buttonSubmit p-1 text-buttonText hover:bg-buttonSubmitHover 2xl:w-full`}
          >
            <option value="EN">{translation("_englishSelection")}</option>
            <option value="GR">{translation("_greekSelection")}</option>
          </select>
        </div>
      </div>

      <div className={`flex ${isMobile ? "flex-col items-center" : "items-center"} 2xl:flex-col 2xl:items-start`}>
        <div className={`just my-4 flex items-center ${isMobile ? "w-full justify-center" : "w-[250px]"}`}>
          <FontAwesomeIcon icon={faPalette} className="mr-2" /> {translation("_appearance")}
        </div>
        <div className="flex w-full">
          <button
            onClick={handleThemeToggle}
            className={`h-[40px] ${isMobile ? "w-[90%]" : "w-[350px]"} rounded bg-buttonSubmit p-1 text-buttonText hover:bg-buttonSubmitHover 2xl:w-full`}
          >
            <FontAwesomeIcon icon={theme === "light" ? faMoon : faSun} className="mr-2 inline-block" />
            {translation(theme === "light" ? "_switchToDark" : "_switchToLight")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreferencesForm;
